
import { useState, useEffect } from 'react';

export const useCSPNonce = () => {
  const [nonce, setNonce] = useState<string>('');

  useEffect(() => {
    // Generate a cryptographically secure nonce
    const generateNonce = () => {
      const array = new Uint8Array(16);
      crypto.getRandomValues(array);
      return btoa(String.fromCharCode(...array)).replace(/[+/=]/g, '');
    };

    setNonce(generateNonce());
  }, []);

  return nonce;
};
